import React from 'react';

import { Badge, BadgeProps } from '@crossnokaye/ux-common/ckds';

import { ActionComponentProps } from './types';

export const ActionComponentBadge: React.FC<ActionComponentProps> = ({ state }) => {
  return (
    <Badge
      className="hover:cursor-default w-full"
      key={`badge-state-${state?.stateName}`}
      onClick={(e: React.MouseEvent<HTMLDivElement>) => {
        e.stopPropagation();
      }}
      variant={state?.actionComponentConfig?.badgeComponentConfig?.variant as BadgeProps['variant']}
    >
      {state?.actionComponentConfig?.badgeComponentConfig?.label ?? ''}
    </Badge>
  );
};
